<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Promoções" sub="Descontos"
      :help="true" titleHelp="Ajuda - Descontos" 
      content="Página responsável por listar os Descontos
Para criação pressione o botão no canto superior direito 'Cadastro'.
Para alteração de um vendedor basta ir com o mouse em ações e clicar em Editar."
      >
      <template v-slot:actions>
        <base-button
          @click="register"
          type="neutral"
          class="ml-3"
          size="sm"
          >Cadastro</base-button
        >
      </template>
    </page-title>
    <modal :show.sync="modals.modal0" id="cadastrar-seções">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">{{ this.discount.id ? 'Editar Desconto' : 'Cadastrar Descontos'}}</h5>
      </template>
      <validation-observer ref="observer">
        <form role="form">
          <div class="row">
            <div class="col-md-12">
              <base-input
                label="Nome"
                placeholder="Nome do desconto"
                v-model="discount.name"
                :required="true"
                rules="required"
                name="name"
              />
            </div>
            <div class="col-md-12">
              <base-input
                label="Porcentagem"
                placeholder="0"
                v-model="discount.percentage"
                :required="true"
                rules="required"
                name="percentage"
                append-icon="fa fa-percent"
              />
            </div>
            <div class="col-md-12">
              <label class="form-control-label d-block mb-3">Validade</label>
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                <el-date-picker
                  v-model="dateRange"
                  :key="dateRange.join()"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Data início"
                  end-placeholder="Data fim"
                  unlink-panels
                  prefix-icon="fa fa-calendar"
                  format="d 'de' MMMM 'de' yyyy"
                  rules="required"
                  :editable="true"
                />
              </base-input>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false"
          >Fechar</base-button
        >
        <base-button type="success" v-loading="loadingSave" :disabled="!this.discount.name || !this.discount.percentage" @click="save">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <span>Descontos</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-10">
            <div>
              <base-input
                label="Nome"
                placeholder="Nome do Desconto"
                v-model="filter.name"
              />
            </div>
          </div>
          <div  class="col-md-2">
            <div style="margin-top: 2rem">
              <base-button v-loading="isLoading"  icon type="primary" v-on:click="search">
                <span class="btn-inner--icon">
                  <i class="fa fa-search"></i>
                </span>
                <span class="btn-inner--text">Pesquisar</span>
              </base-button>
            </div>
          </div>
        </div>
      </form>
      <el-table
        v-loading="isLoading"
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="discounts"
        @row-click="rowClicked"
        ref="discounts"
      >
        <el-table-column label="Nome" prop="name" min-width="200px" sortable />
        <el-table-column label="Porcentagem" prop="percentage" min-width="140px" sortable />
        <el-table-column label="Data Início" v-slot="{ row }" min-width="120px" sortable>
          {{ row.start_date | humanDate }}
        </el-table-column>
        <el-table-column label="Data Fim" v-slot="{ row }" min-width="120px" sortable>
          {{ row.end_date | humanDate }}
        </el-table-column>
        <el-table-column
          label="Ações"
          min-width="120px"
          prop="acoes"
          v-slot="{ row }"
        >
          <div class="row">
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer"
            >
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
                <a class="dropdown-item" href="#" @click="remove(row)"
                  >Excluir</a
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import { ValidationProvider, extend } from "vee-validate";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
extend("required", isValid => {
  if(isValid){
    return true
  }
  return "Este campo é obrigatório";
});

export default {
  name: "app",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    ValidationProvider,
    flatPicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      modals: {
        modal0: false,
      },
      branches: [],
      discounts: [],
      discount: {},
      discount_types: [],
      filter: {},
      errors: [],
      filtered: false,
      paginated_data: [],
      formData: {},
      isLoading: false,
      start_date: "Data de Início",
      end_date: "Data de Fim",
      loadingSave: false
    };
  },
  created() {
    if(this.$can('index', 'discount')){
      this.setData();
    }
  },
  methods: {
    rowClicked(row) {
      this.$refs.discounts.toggleRowExpansion(row);
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    async setData(q, page) {
      this.isLoading = true;
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;
      try {
        const response = await this.$http.secured.get("/api/v1/discounts", {
          params: {
            page: page,
            q: q,
          },
        })
        this.paginated_data = response.data;
        this.discounts = this.paginated_data["discounts"];
        this.discount.discount_type = "product";
        this.isLoading = false;
        this.isLoadingSearch = false;
      } catch (error) {
        console.error("[Discounts][setData]", error);
      } finally {
        this.isLoading = false;
      }
    },
    async setDiscountTypes() {
      try {
       const response = await this.$http.secured.get("/api/v1/discounts/discount_types")
        this.discount_types = response.data;
      } catch (error) {
        console.log("[Disocunts][setDiscountTypes]", error);
      }
    },
    search() {
      this.isLoadingSearch = true;
      // // a flag filtered é verdadeira quando algo é pesqusado
      // // No caso se os campos de pesquisa estão vazios ela é falsa
      this.filtered = !this.emptyFilter;
      this.setData(this.normalizedFilter);
      // console.log('Filter: ', {...this.normalizedFilter})
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData(filterInput, page);
    },
    async save() {
      this.loadingSave = true;
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$toasted.global.defaultError({
          msg: "Por favor, preencha todos os campos obrigatórios.",
        });
        this.loadingSave = false;
        return;
      }

      try {
        await this.$http.secured(this.reqParams);
        this.$toasted.global.defaultSuccess();
        this.setData();
        this.modals.modal0 = false;
        this.resetInputs();
        this.$refs.observer.reset();
      } catch (error) {
        console.error("[Discounts][save]", error);
        this.$toasted.global.defaultError();
      } finally {
        this.loadingSave = false;
      }
    },
    edit(discount) {
      this.discount = discount;
      this.modals.modal0 = true;
    },
    async remove(discount) {
      try {
        await this.$http.secured.delete(`/api/v1/discounts/${discount.id}`, discount)
        this.$toasted.global.defaultSuccess();
        this.setData();
      } catch (error) {
        console.log("[Discounts][remove]", error);
        this.$toasted.global.defaultError();
      }
    },
    resetInputs() {
      this.filter = {};
      this.discount = {};
      this.marker = {};
    },
    register() {
      this.filter = {};
      this.discount = {};
      this.marker = {};
      this.modals.modal0 = true
    }
  },
  computed: {
    reqParams: function () {
      if (this.discount.hasOwnProperty("id")) {
        return {
          url: `/api/v1/discounts/${this.discount.id}`,
          method: "patch",
          data: this.discount,
        };
      }

      return {
        url: `/api/v1/discounts`,
        method: "post",
        data: this.discount,
      };
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    normalizedFilter: function () {
      let filter = this.filter;
      for (let key in filter) {
        // replacing objects by ids
        if (filter.hasOwnProperty(key) && typeof filter[key] == "object") {
          filter[key + "_id"] = filter[key].id;
          delete filter[key];
        }
        // removing empty fields
        if (filter[key] == "") {
          try {
            delete q[key];
          } catch (error) {
            console.warn(error);
          }
        }
      }
      return filter;
    },
    dateRange: {
      get: function () {
        // eslint-disable-next-line
        /* eslint-disable */

        return [this.start_date, this.end_date];
      },
      set: function (range) {
        // eslint-disable-next-line
        /* eslint-disable */
        [this.start_date, this.end_date] = range;
      },
    },
  },
  watch: {
    start_date: function () {
      this.discount.start_date = this.start_date;
    },
    end_date: function () {
      this.discount.end_date = this.end_date;
    },
  },
};
</script>